// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__ml_bD","footer_logo":"styles_footer_logo__iDT71","links":"styles_links__jaM2w","link":"styles_link__6YQiB","copyright":"styles_copyright__twNVa"};